/* Source: /home/ubuntu/libredraw/frontend/editor/DiagramTabs.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { X } from "lucide-react";
import { cn } from "../../lib/utils.js";
function DiagramTabs(props) {
  const {tabs: tabs = null, activeId: activeId = "", onSwitch: onSwitch = null, onClose: onClose = null} = props;
  let items = (tabs || []);
  if ((items.length <= 1)) {
    return null;
  }
  return __jacJsx("div", {"className": "flex h-9 shrink-0 items-center gap-1 overflow-x-auto border-b border-border bg-card px-2"}, [items.map(t => __jacJsx("div", {"key": t["id"], "data-diagram-tab": t["id"], "className": cn("group flex shrink-0 items-center rounded-md", ((t["id"] === activeId) ? "bg-primary-soft text-primary" : "text-muted-foreground hover:bg-accent hover:text-foreground"))}, [__jacJsx("button", {"onClick": _e => {
    if ((onSwitch && (t["id"] !== activeId))) {
      onSwitch(t["id"]);
    }
  }, "title": String((t["name"] || "Untitled")), "className": cn("max-w-[168px] truncate py-1 pl-3 pr-1.5 text-xs", ((t["id"] === activeId) ? "font-medium" : ""))}, [String((t["name"] || "Untitled"))]), __jacJsx("button", {"onClick": _e => {
    if (onClose) {
      onClose(t["id"]);
    }
  }, "title": "Close (keeps the diagram in your list)", "aria-label": "Close tab", "className": "mr-1 flex size-5 items-center justify-center rounded text-muted-foreground opacity-60 hover:bg-black/10 hover:text-foreground group-hover:opacity-100"}, [__jacJsx(X, {"size": 12}, [])])]))]);
}
/*jac:refresh-boundary*/;
export {DiagramTabs};
//# sourceMappingURL=DiagramTabs.js.map
